import { BuiltinModuleTag } from "@scayla/api-client-fetch";

export const BUILTIN_MODULE_SORT_ORDER = [
  BuiltinModuleTag.EMAILS,
  BuiltinModuleTag.CONTACTS,
  BuiltinModuleTag.DOCUMENTS,
  BuiltinModuleTag.FILES,
  BuiltinModuleTag.PROJECTS,
  BuiltinModuleTag.ASSETS,
  BuiltinModuleTag.ACCOUNTING,
  BuiltinModuleTag.PRODUCTS,
];

export function getModuleIcon(tag?: BuiltinModuleTag) {
  switch (tag) {
    case BuiltinModuleTag.DOCUMENTS:
      return "generic/dossier-module";
    case BuiltinModuleTag.CONTACTS:
      return "phosphor/users";
    case BuiltinModuleTag.PROJECTS:
      return "phosphor/suit-case-simple";
    case BuiltinModuleTag.ASSETS:
      return "phosphor/chart-line";
    case BuiltinModuleTag.EMAILS:
      return "phosphor/mail";
    case BuiltinModuleTag.FILES:
      return "phosphor/file";
    case BuiltinModuleTag.ACCOUNTING:
      return "phosphor/calculator";
    case BuiltinModuleTag.SETTINGS_ACCOUNTING:
      return "phosphor/gear";
    case BuiltinModuleTag.PRODUCTS:
      return "phosphor/barcode";
    default:
      return undefined;
  }
}

export function canCreateRecordsByModuleTag(tag?: BuiltinModuleTag): boolean {
  if (!tag) return true;

  return tag !== BuiltinModuleTag.FILES;
}
